import { render, staticRenderFns } from "./CallDetailsRejected.vue?vue&type=template&id=7f36c416&"
import script from "./CallDetailsRejected.vue?vue&type=script&lang=js&"
export * from "./CallDetailsRejected.vue?vue&type=script&lang=js&"
import style0 from "./CallDetailsRejected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports